import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOrdersRequest,
  createOrderRequest,
  updateOrderRequest,
} from '../../redux/actions/orderActions';
import { fetchHomeDataRequest } from '../../redux/actions/homeActions';
import PurchaseOrder from '../../components/PurchaseOrder';

const PurchaseOrderContainer = () => {
  const dispatch = useDispatch();
  const { orders, loading, error } = useSelector(state => state.orders);
  const { vendors, products, delivery_addresses } = useSelector(state => state.home);
  const [showForm, setShowForm] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [formData, setFormData] = useState({
    firmName: '',
    vendorId: '',
    productId: '',
    quantity: '',
    rate: '',
    deliveryAddress: ''
  });

  useEffect(() => {
    // Load home data instead of orders on component mount
    dispatch(fetchHomeDataRequest());
  }, [dispatch]);

  const handleOrderHistoryClick = () => {
    dispatch(fetchOrdersRequest());
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentOrder) {
      dispatch(updateOrderRequest(currentOrder.id, formData));
    } else {
      dispatch(createOrderRequest(formData));
    }
    resetForm();
  };

  const handleEdit = (order) => {
    setCurrentOrder(order);
    setFormData({
      orderNumber: order.orderNumber,
      supplierName: order.supplierName,
      items: order.items,
      totalAmount: order.totalAmount,
      orderDate: order.orderDate,
      deliveryDate: order.deliveryDate,
      status: order.status
    });
    setShowForm(true);
  };


  const resetForm = () => {
    setFormData({
      firmName: '',
      vendorId: '',
      productId: '',
      quantity: '',
      rate: '',
      deliveryAddress: ''
    });
    setCurrentOrder(null);
    setShowForm(false);
  };

  return (
    <PurchaseOrder
      orders={orders}
      loading={loading}
      error={error}
      showForm={showForm}
      formData={formData}
      currentOrder={currentOrder}
      vendors={vendors}
      products={products}
      deliveryAddresses={delivery_addresses}
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      handleEdit={handleEdit}
      handleOrderHistoryClick={handleOrderHistoryClick}
      resetForm={resetForm}
      setShowForm={setShowForm}
    />
  );
};

export default PurchaseOrderContainer;